import { render, staticRenderFns } from "./ChipRowV2026.vue?vue&type=template&id=027e83c8&scoped=true"
import script from "./ChipRowV2026.vue?vue&type=script&lang=js"
export * from "./ChipRowV2026.vue?vue&type=script&lang=js"
import style0 from "./ChipRowV2026.vue?vue&type=style&index=0&id=027e83c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e83c8",
  null
  
)

export default component.exports